import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TwoFACheck from './TwoFACheck';
import Instructions from './Instructions';
import LinkAuthenticator from './LinkAuthenticator';
import RecoveryCodes from './RecoveryCodes';

const Enable2FA = (): JSX.Element => {
  return (
    <Routes>
      <Route path='/' element={<Instructions />} />
      <Route path='/LinkAuthenticator' element={<LinkAuthenticator />} />
      <Route path='/2FA' element={<TwoFACheck />} />
      <Route path='/RecoveryCodes' element={<RecoveryCodes />} />
    </Routes>
  );
};

export default Enable2FA;
